import { styled } from "styled-components";
const EmImpl = styled("em")({
  fontStyle: "italic"
});
export {
  EmImpl
};
